module.exports = __webpack_public_path__ + "8a5356e9/img/at-icon.5d6fc5d8.svg";